export const nl = {
  // Navigation
  nav: {
    about: "Over Mij",
    portfolio: "Portfolio", 
    resume: "CV",
    werkwijze: "Werkwijze",
    contact: "Contact"
  },

  // About Section
  about: {
    eyebrow: "Over Mij",
    title: "Web Developer & Designer",
    hello: "Online",
    lead: "Het vormgeven van de toekomst van web & AI · Software visionair · AI innovator. Ik zet ideeën om in werkelijkheid met doordacht ontwerp en betrouwbare code.",
    tags: {
      frontend: "Frontend (80%)",
      backend: "Backend (10%)",
      ai: "Kunstmatige Intelligentie (10%)"
    },
    kpis: {
      experience: "Jaar Ervaring",
      hours: "Uren Werk",
      projects: "Projecten Voltooid"
    }
  },

  // Portfolio Section
  portfolio: {
    eyebrow: "Portfolio",
    title: "Mijn Werk",
    viewDesign: "Bekijk Design",
    projects: {
      ventilation: "Ventilatie Bedrijf Website",
      aiPlanner: "AI Planner App Design",
      fulfillment: "Fulfillment Bedrijf Website",
      aiSignatures: "AI Handtekeningen App Design",
      glass: "Glas Bedrijf Website"
    }
  },

  // Resume Section
  resume: {
    title: "CV",
    subtitle: "Opleiding & Ervaring",
    education: {
      title: "Opleiding",
      bachelor: {
        title: "Bachelor Diploma",
        school: "Universiteit van Amsterdam",
        period: "2023 – 2026",
        description: "Focus op software engineering & werking van AI."
      },
      vwo: {
        title: "VWO",
        school: "Lyceum Kralingen",
        period: "2017 – 2023",
        description: "Focus op wiskunde, natuurkunde, scheikunde en biologie."
      }
    },
    experience: {
      title: "Ervaring",
      frontend: {
        title: "Frontend Developer",
        company: "Freelance",
        period: "2023 – Heden",
        description: "Ontwikkeling van moderne web applicaties met React.js, HTML, CSS, SCSS en Python. Focus op responsive design en gebruikerservaring."
      },
      webdev: {
        title: "Web Developer",
        company: "Freelance",
        period: "2023 – Heden",
        description: "Gebouwd websites en web applicaties met HTML, CSS, SCSS en JavaScript. Ervaring met Python voor backend ontwikkeling en data analyse."
      }
    }
  },

  // Werkwijze Section
  werkwijze: {
    eyebrow: "Werkwijze",
    title: "Hoe Ik Werk",
    documentTitle: "Werkwijze Document",
    pages: "pagina's",
    open: "Open",
    download: "Download"
  },

  // Contact Section
  contact: {
    eyebrow: "Contact",
    title: "Neem Contact Op",
    form: {
      name: "Naam",
      email: "E-mail",
      subject: "Onderwerp",
      message: "Bericht",
      namePlaceholder: "Jouw naam",
      emailPlaceholder: "jouw.email@voorbeeld.nl",
      subjectPlaceholder: "Project aanvraag",
      messagePlaceholder: "Vertel me over je project...",
      submit: "Verstuur Bericht",
      sending: "Versturen...",
      sent: "Verzonden! ✓",
      error: "Fout - Probeer opnieuw"
    },
    success: "Bedankt voor je bericht! Ik neem zo snel mogelijk contact met je op.",
    error: "Er is een fout opgetreden bij het versturen van je bericht. Probeer het opnieuw of neem direct contact op via info@mouadkasmi.com.",
    info: {
      email: "info@mouadkasmi.com",
      location: "Amsterdam, Nederland"
    }
  },

  // Footer
  footer: {
    copyright: "© 2024 Mouad Kasmi. Alle rechten voorbehouden."
  }
};
